import { BudgetBys } from 'business/constants';

export type SoftwareConfig = {
    showCommentColumn: boolean;
    software: string;
};

export type InscriptionsModalOptions = {
    commentColumn: string[];
    inscriptionSource: string[];
    keepInscription: string[];
    keepProject: string[];
    phase: string[];
    resetInscriptionOption: string[];
    softwareConfig: SoftwareConfig[];
    year: number[];
    step: string[];
};

export enum InscriptionSource {
    PhaseInscriptions = 'phase_inscriptions',
    BudgetLineInscriptions = 'budget_line_inscriptions',
}

type InscriptionsSummary = {
    deleted: number;
    error: string;
    infos: string[];
    inscriptionsCreated: number;
    isError: boolean;
    orphans: number;
    skipped: { missingResource: number; badResource: number };
};

export type InscriptionsSummaryByBP = {
    budgetProposalId: number;
    budgetProposalName: string;
    resourceType: BudgetBys;
    logs: InscriptionsSummary;
};

export type InitInscriptionsLogs = {
    executionSummary: InscriptionsSummaryByBP[];
};

export type InitializeInscriptionPayload = {
    software: string;
    inscriptionSource: string;
    year: number;
    budgetProposalIds: number[];
    resources: string[];
    keepInscription: string;
    resetInscriptionOption: string;
    step?: string[];
    phase?: string;
    commentColumn?: string;
    keepProject?: string;
};
